import { UserOutlined, WarningOutlined } from '@ant-design/icons'
import { ProviderAccount } from '@prisma/client'
import { Avatar, Flex, Tooltip, Typography } from 'antd'
import React from 'react'

type Props = {
  providerAccount: ProviderAccount
}

export const ProviderAccountLabel: React.FC<Props> = ({ providerAccount }) => {
  const pictureUrl = providerAccount.pictureUrl
  const isCorrupted = providerAccount.status === 'CORRUPTED'
  const configuration: any = providerAccount.configuration

  return (
    <Flex gap={8} align="center">
      {pictureUrl ? (
        <>
          <Avatar shape="square" size="small" src={pictureUrl} />
        </>
      ) : (
        <UserOutlined />
      )}

      <Typography.Text ellipsis>
        {configuration.email ?? providerAccount.name}
      </Typography.Text>

      {isCorrupted && (
        <Tooltip title={`Click on "Connect account" again`}>
          <Typography.Text type="warning">
            <WarningOutlined /> Connection issue
          </Typography.Text>
        </Tooltip>
      )}
    </Flex>
  )
}
